import { UserGateway } from './user-gateway.interface';

export const initUserAPI = (apiSlice: any, gateway: UserGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['User'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getUserById: builder.query({
          query: gateway.getUserById,
          providesTags: (result: any, error: any, arg: any) => [
            { type: 'User', id: arg },
          ],
        }),
        getToken: builder.query({
          query: gateway.getToken,
        }),
        forgotPassword: builder.query({
          query: gateway.forgotPassword,
        }),
        resetPassword: builder.query({
          query: gateway.postResetPassword,
        }),
        getProfile: builder.query({
          query: gateway.getProfile,
        }),
        searchCustomers: builder.query({
          query: gateway.searchCustomers,
        }),
        patchCustomer: builder.mutation({
          query: gateway.patchCustomer,
          invalidatesTags: ['User'],
        }),
        getEmployeesByTeam: builder.query({
          query: gateway.getEmployeesByTeam,
        }),
        postSendAccess: builder.query({
          query: gateway.postSendAccess,
        }),
        getAchivesClients: builder.query({
          query: gateway.getArchiveClients,
        }),
        getArchivesClientsCount: builder.query({
          query: gateway.getArchiveClientsCount,
        }),
        getCustomerToken: builder.query({
          query: gateway.getCustomerToken,
        }),
        deleteUserRelated: builder.mutation({
          query: gateway.deleteUserRelated,
          invalidatesTags: ['Project', 'User'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface UserSliceType {
  useGetUserByIdQuery: Function;
  useGetTokenQuery: Function;
  useForgotPasswordQuery: Function;
  useLazyForgotPasswordQuery: Function;
  useResetPasswordQuery: Function;
  useLazyResetPasswordQuery: Function;
  useGetProfileQuery: Function;
  useSearchCustomersQuery: Function;
  useLazySearchCustomersQuery: Function;
  usePatchCustomerMutation: Function;
  useGetEmployeesByTeamQuery: Function;
  useLazyGetEmployeesByTeamQuery: Function;
  usePostSendAccessQuery: Function;
  useLazyPostSendAccessQuery: Function;
  useGetAchivesClientsQuery: Function;
  useLazyGetAchivesClientsQuery: Function;
  useGetArchivesClientsCountQuery: Function;
  useLazyGetArchivesClientsCountQuery: Function;
  useGetCustomerTokenQuery: Function;
  useLazyGetCustomerTokenQuery: Function;
  useDeleteUserRelatedMutation: Function;
  useLazyDeleteUserRelatedMutation: Function;
}
